import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import { StepperFormStore } from '../../../+state/firmware-package/stepper-form.store';
import { PackageMetadataFormType } from '../../../entities/models/firmware-stepper.model';

@Component({
  standalone: true,
  selector: 'remote-update-domain-package-metadata',
  templateUrl: './package-metadata.html',
  styleUrls: ['./package-metadata.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatButtonToggleModule,
    FormsModule
  ]
})
export class PackageMetadata implements OnInit {
  @Input() currentSection = '';
  private store = inject(StepperFormStore);

  @Output() formSubmitted = new EventEmitter<{ valid: boolean; value: PackageMetadataFormType }>();

  packageMetadataForm = new FormGroup<{
    classification: FormControl<string>;
    packageName: FormControl<string>;
  }>({
    classification: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    packageName: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(100)]
    })
  });

  ngOnInit() {
    const packageMetadata = this.store.packageMetadata();
    this.packageMetadataForm.patchValue(
      {
        classification: packageMetadata.classification,
        packageName: packageMetadata.packageName
      },
      { emitEvent: false }
    );

    if (this.store.isEditingFirmwarePackage()) {
      this.store.updatePackageMetadata({
        classification: packageMetadata.classification,
        packageName: packageMetadata.packageName,
        isValid: true
      });
    }

    this.packageMetadataForm.valueChanges.forEach(() => {
      const { classification, packageName } = this.packageMetadataForm.getRawValue();
      this.store.updatePackageMetadata({
        classification: classification.trim(),
        packageName: packageName.trim(),
        isValid: this.packageMetadataForm.valid
      });
    });
  }

  markTouchedAndValidate(): boolean {
    this.packageMetadataForm.markAllAsTouched();
    return this.packageMetadataForm.valid;
  }

  get error(): string | undefined {
    return this.store.errors().packageMetadata;
  }
}
